// extracted by mini-css-extract-plugin
module.exports = {"Button":"CommentDropDownMenu_Button__jNpmY","Icon":"CommentDropDownMenu_Icon__z27ZO","Checkbox":"CommentDropDownMenu_Checkbox__xRuju"};